import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { GuestGuard } from 'src/app/guards/guest.guard';

const routes: Routes = [
  {
    canLoad: [AuthGuard],
    path: 'admin',
    loadChildren: () =>
      import('src/app/modules/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'update/:hash',
    loadChildren: () =>
      import('src/app/modules/update/update.module').then(
        (m) => m.UpdateModule
      ),
  },
  {
    canLoad: [GuestGuard],
    path: '',
    loadChildren: () =>
      import('src/app/modules/admin/submodules/login/login.module').then(
        (m) => m.LoginModule
      ),
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
